module.exports = __webpack_public_path__ + "img/new_02.cddfa6d7.jpg";